import { Checkbox } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';

function _Checkbox(_ref, _ref2) {
  var inline = _ref.inline,
      label = _ref.label,
      name = _ref.name;
  var form = _ref2.form;

  var checked = form.get(name) === 'on';
  var handleChange = function handleChange() {
    return form.set(name, checked ? 'off' : 'on');
  };

  return React.createElement(
    Checkbox,
    { checked: checked, inline: inline, onChange: handleChange },
    label
  );
}

_Checkbox.contextTypes = {
  form: PropTypes.object.isRequired
};

_Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  inline: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
} : {};

export default _Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/Checkbox.js
// module id = 261
// module chunks = 0